import { useCallback } from 'react';
export var useHeadingSave = function useHeadingSave(_ref) {
  var localTitle = _ref.localTitle,
      localDescription = _ref.localDescription,
      headingLabel = _ref.headingLabel,
      onSaveHeading = _ref.onSaveHeading,
      onUpdateHeading = _ref.onUpdateHeading;
  var handleSaveHeading = useCallback(function () {
    // Get the latest values
    // Check if title is empty or whitespace only, use 'current' as default when saving/creating
    var trimmedTitle = (localTitle === null || localTitle === void 0 ? void 0 : localTitle.trim()) || '';
    var titleToSave = trimmedTitle || 'current'; // Allow empty description - don't set default

    var descriptionToSave = localDescription || ''; // Clean description (remove empty p tags)

    var cleanedDescription = descriptionToSave.replace(/^<p>|<\/p>$/g, ''); // Update fields if callback provided

    if (onUpdateHeading) {
      onUpdateHeading('title', titleToSave);
      onUpdateHeading('description', cleanedDescription);
    } // Call onSaveHeading with same format as before: { title: string; description: string }


    onSaveHeading({
      title: titleToSave,
      description: cleanedDescription
    });
  }, [localTitle, localDescription, onSaveHeading, onUpdateHeading]);
  return {
    handleSaveHeading: handleSaveHeading
  };
};